export function normalizeCustomDomain(value: unknown): string {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return '';

  const withoutProtocol = raw.replace(/^https?:\/\//i, '');
  return withoutProtocol.split(/[/?#]/)[0].replace(/\.$/, '');
}

export function isValidCustomDomain(value: unknown): boolean {
  const hostname = normalizeCustomDomain(value);
  if (!hostname || hostname.length > 253 || !hostname.includes('.')) return false;

  const labels = hostname.split('.');
  return labels.every((label) =>
    label.length > 0 &&
    label.length <= 63 &&
    /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(label)
  );
}

export function isOnlineStoreInformationComplete(
  email: unknown,
  brandColors: unknown,
  templateKey: unknown
): boolean {
  const normalizedEmail = String(email || '').trim();
  const hasValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);

  return hasValidEmail &&
    Array.isArray(brandColors) &&
    brandColors.length > 0 &&
    !!String(templateKey || '').trim();
}
